import omit from 'lodash/omit';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BaseSection from './BaseSection';
import { formFields } from '../components/ContactForm';
import { Columns, Column, ContactForm } from '../components';
import { withComponents } from '../components/Context';
import { withAppContext } from '../Context';
import { hasContactEmail, hasValidContactEmail } from '../utils/siteValidation';
import { appDataProps } from '../utils/propTypes';
import MissingContactEmailWarning from './components/MissingContactEmailWarning';

class ContactSection extends PureComponent {
  render() {
    const { fields, strings, image, imagePosition, components, data, isEditing, editor, ...props } =
      this.props;
    const { Image } = components;
    const showMissingEmailWarning = isEditing && !hasValidContactEmail(data?.site);
    const emailWarningVariant = hasContactEmail(data?.site) ? 'invalid' : 'missing';
    // `data` comes from AppContext and must not end up in the section block (duplicate/save)
    const block = omit(this.props, ['data']);
    // TODO : use fields to filter formFields
    return (
      <BaseSection {...props} editor={editor} isEditing={isEditing} block={block}>
        {showMissingEmailWarning && (
          <MissingContactEmailWarning
            variant={emailWarningVariant}
            onConfigure={editor?.openContactSettings}
          />
        )}
        <Columns isCentered centerVertically>
          {imagePosition === 'left' && (
            <Column size={6}>
              <Image src={image} maxWidth={700} />
            </Column>
          )}
          <Column size={imagePosition && imagePosition !== 'none' ? 6 : 9}>
            <ContactForm fields={Array.isArray(fields) ? fields : formFields} strings={strings} />
          </Column>
          {imagePosition === 'right' && (
            <Column size={6}>
              <Image src={image} maxWidth={700} />
            </Column>
          )}
        </Columns>
      </BaseSection>
    );
  }
}

ContactSection.defaultProps = {
  fields: undefined,
  strings: {},
  image: undefined,
  imagePosition: 'none',
  isEditing: false,
  data: undefined,
  editor: undefined,
};

ContactSection.propTypes = {
  components: PropTypes.object.isRequired,
  data: appDataProps,
  fields: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        children: PropTypes.arrayOf(
          PropTypes.shape({ name: PropTypes.string, type: PropTypes.string }),
        ),
      }),
    ),
  ]),
  isEditing: PropTypes.bool,
  editor: PropTypes.shape({
    openContactSettings: PropTypes.func,
  }),
  strings: PropTypes.object,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imagePosition: PropTypes.oneOf(['none', 'left', 'right']),
};

export default withAppContext(withComponents(ContactSection));
